import Styled from 'vue3-styled-components';

const DrawerStyle = Styled.div`

`;

export { DrawerStyle };
